class PremiumFarmStory extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.media = this.querySelector('[data-farm-media]');
    this.frame = this.querySelector('[data-farm-frame]');
    this.raf = 0;

    requestAnimationFrame(() => this.classList.add('is-ready'));

    if (this.dataset.reveal === 'true' && !this.reduceMotion && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: '100px 0px',
        threshold: 0.12,
      });
      this.observer.observe(this);
    } else {
      this.dataset.visible = 'true';
    }

    if (this.dataset.tilt === 'true' && this.media && !this.reduceMotion) {
      this.media.addEventListener('pointermove', this.onPointerMove);
      this.media.addEventListener('pointerleave', this.onPointerLeave);
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.media?.removeEventListener('pointermove', this.onPointerMove);
    this.media?.removeEventListener('pointerleave', this.onPointerLeave);
    if (this.raf) cancelAnimationFrame(this.raf);
  }

  onIntersect = (entries) => {
    if (!entries[0]?.isIntersecting) return;
    this.dataset.visible = 'true';
    this.observer?.disconnect();
  };

  onPointerMove = (event) => {
    if (event.pointerType === 'touch' || !this.frame) return;
    const rect = this.media.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    const strength = Number(this.dataset.tiltStrength) || 2;

    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => {
      this.frame.style.setProperty('--farm-rotate-x', `${-y * strength}deg`);
      this.frame.style.setProperty('--farm-rotate-y', `${x * strength}deg`);
      this.frame.style.setProperty('--farm-light-x', `${(x + 0.5) * 100}%`);
      this.frame.style.setProperty('--farm-light-y', `${(y + 0.5) * 100}%`);
    });
  };

  onPointerLeave = () => {
    if (!this.frame) return;
    this.frame.style.setProperty('--farm-rotate-x', '0deg');
    this.frame.style.setProperty('--farm-rotate-y', '0deg');
    this.frame.style.setProperty('--farm-light-x', '50%');
    this.frame.style.setProperty('--farm-light-y', '50%');
  };
}

if (!customElements.get('premium-farm-story')) {
  customElements.define('premium-farm-story', PremiumFarmStory);
}
